import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SplitText, Reveal } from '../fx/Reveal';
type Crumb = {
  label: string;
  to?: string;
};
type Props = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  crumbs?: Crumb[];
};
export function PageHero({
  eyebrow,
  title,
  subtitle,
  crumbs
}: Props) {
  return <section className="relative overflow-hidden pt-40 pb-16" data-id="element-353" data-mp="1cd467si0jngu">
      <div className="absolute left-1/2 top-24 -z-[1] h-72 w-72 -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(45,168,255,0.22),transparent_70%)] blur-3xl" data-id="element-354" data-mp="1ca89u8ltd6ui" />
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-355" data-mp="12ctte8zw4i27">
        {crumbs && <Reveal data-id="element-356" data-mp="xeiirw1ru3ix">
            <nav className="mb-6 flex items-center justify-center gap-1.5 text-xs font-medium text-slate" data-id="element-357" data-mp="xf21hez8wvy0">
              {crumbs.map((c, i) => <span key={i} className="flex items-center gap-1.5" data-id="element-358" data-mp="3i5173hstisxg" data-mpi={i}>
                  {c.to ? <Link to={c.to} className="transition-colors hover:text-royal" data-id="element-359" data-mp="2t3gvbvnk8cp7">
                      {c.label}
                    </Link> : <span className="text-royal" data-id="element-360" data-mp="2j5147soj93fp">{c.label}</span>}
                  {i < crumbs.length - 1 && <ChevronRightIcon className="h-3 w-3" data-id="element-361" data-mp="2o706ez8jdub2" />}
                </span>)}
            </nav>
          </Reveal>}
        {eyebrow && <Reveal data-id="element-362" data-mp="2f5jvmqdt7q6b">
            <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-royal/20 bg-white/70 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-royal" data-id="element-363" data-mp="2f622si20fot0">
              {eyebrow}
            </span>
          </Reveal>}
        <SplitText as="h1" text={title} className="font-display text-4xl font-bold leading-[1.05] text-navy sm:text-5xl md:text-6xl" data-id="element-364" data-mp="1rfxxm696bgzw" />
        {subtitle && <Reveal delay={0.15} data-id="element-365" data-mp="1yatxzka4vys">
            <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate md:text-lg" data-id="element-366" data-mp="1zlyw2pgo9rh">
              {subtitle}
            </p>
          </Reveal>}
      </div>
    </section>;
}